// User IDs treated as developers for feature-flag gating (e.g. dev-only
// report internals). Shared so the client hook and server-side guards stay
// in sync.
export const DEVELOPER_USER_IDS = [
  "clr8igt9c00004vzfbfzsxmq2",
  "clr8jioyu00003pumjts69byh",
  "cmpupdgax00020cl86hukfk52",
];

export function isDeveloperUserId(userId) {
  return DEVELOPER_USER_IDS.includes(userId);
}
